import Vue from 'vue'
import siteOptions from '@/config/index'
import { vueRoutesAdapter, getDemoRoutes, getFavLayout } from '@/framework/utils/config'
import HeaderLeftMainLayout from '@/framework/layouts/HeaderLeftMainLayout'

import frameworkUserRouter from '@/config/router'
import { mainMenuConfig ,isShowKeyclient } from '@/config/menu'
import { getPageRouterList, addMenuTab } from '@/framework/utils/layout'

// 资源加载进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  minimum: 0.1,
  easing: 'ease',
  speed: 500,
  showSpinner: false
});

export function getAppRouter(appRouter){
  const finalRoutes = frameworkUserRouter;
  // 示例页面路由。
  const demoRoutes = (getDemoRoutes()['pages']).map(page=>{
    return {
      path: page['router'] || page['path'],
      component: HeaderLeftMainLayout,
      children: [{
        path: '',
        meta: page['meta'] || {},
        component: () => import(`@/framework${page['path']}/index.js`)
      }]
    }
  })
  // 手动从代码中添加的路由。
  const customRoutes = [
    {
      path: '/',
      redirect: siteOptions['indexPath'] || '/'
    },
    {
      path: '*/iframe',
      component: HeaderLeftMainLayout,
      children: [{
        path: '',
        component: isShowKeyclient?()=> import('@/framework/components/iframe'): ()=>import('@/framework/components/basic-not-found')
      }]
    },
    {
      path: '*',
      component: HeaderLeftMainLayout,
      children: [{
        path: '',
        component: ()=>import('@/framework/components/basic-not-found')
      }]
    }
  ]
  // 应用全局 layout。
  let allRoutes = [...demoRoutes, ...finalRoutes, ...customRoutes]
  let favLayout = getFavLayout()
  if(favLayout) {
    allRoutes.forEach(route=>{
      route['component'] = ()=>import(`@/framework/layouts/${favLayout}`)
    })
  }

  appRouter.addRoutes(allRoutes)
	appRouter.beforeEach((to, from, next) => {
	  NProgress.start()
	  let routerPath = to.fullPath
	  let menuTitle = ''
	  if(routerPath != '/') {
	    menuTitle = getPageRouterList(mainMenuConfig, routerPath);
	    if(menuTitle.length){
	      menuTitle = menuTitle[menuTitle.length - 1]['name']
	    } else {
	      menuTitle = '404'
	    }
	  } else {
	    menuTitle = '首页'
	  }
	  addMenuTab({
	    title: menuTitle,
	    name: routerPath,
	    path: routerPath
	  })
	  next()
	})
	appRouter.afterEach(transition => {
	  NProgress.done()
	})
	return appRouter
}
